/**
 * Send welcome email to new waitlist member
 */
export async function sendWelcomeEmail(
  email: string,
  name: string | undefined,
  referralCode: string
): Promise<{ success: boolean; message: string }> {
  try {
    const response = await fetch("/api/send-welcome", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email,
        name,
        referralCode,
      }),
    })

    const data: unknown = await response.json()

    if (!response.ok) {
      const errorMessage =
        data && typeof data === "object" && "error" in data && typeof data.error === "string"
          ? data.error
          : "Failed to send welcome email"
      throw new Error(errorMessage)
    }

    const message =
      data && typeof data === "object" && "message" in data && typeof data.message === "string"
        ? data.message
        : "Email sent successfully"

    return {
      success: true,
      message,
    }
  } catch (error) {
    console.error("Error sending welcome email:", error)
    return {
      success: false,
      message: error instanceof Error ? error.message : "Failed to send welcome email",
    }
  }
}

/**
 * Send referral invitation emails via Resend
 */
export async function sendReferralEmails(
  referrerEmail: string,
  referrerName: string | undefined,
  referralCode: string,
  recipientEmails: string[]
): Promise<{ success: boolean; message: string; summary?: { total: number; successful: number; failed: number } }> {
  try {
    const response = await fetch("/api/send-referrals", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        referrerEmail,
        referrerName,
        referralCode,
        recipientEmails,
      }),
    })

    const data: unknown = await response.json()

    if (!response.ok) {
      const errorMessage =
        data && typeof data === "object" && "error" in data && typeof data.error === "string"
          ? data.error
          : "Failed to send emails"
      throw new Error(errorMessage)
    }

    const message =
      data && typeof data === "object" && "message" in data && typeof data.message === "string"
        ? data.message
        : "Emails sent successfully"

    const summary =
      data &&
      typeof data === "object" &&
      "summary" in data &&
      data.summary &&
      typeof data.summary === "object" &&
      "total" in data.summary &&
      "successful" in data.summary &&
      "failed" in data.summary &&
      typeof data.summary.total === "number" &&
      typeof data.summary.successful === "number" &&
      typeof data.summary.failed === "number"
        ? {
            total: data.summary.total,
            successful: data.summary.successful,
            failed: data.summary.failed,
          }
        : undefined

    return {
      success: true,
      message,
      summary,
    }
  } catch (error) {
    console.error("Error sending referral emails:", error)
    return {
      success: false,
      message: error instanceof Error ? error.message : "Failed to send emails",
    }
  }
}
